import { takeLatest } from 'redux-saga/effects';
import { loginSaga } from './authentication-saga';

import * as types from '../actions';

export default function* watchUserAuthentication() {
    yield takeLatest(types.LOGIN_USER, loginSaga);
}
